import { Component, computed, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { NotificationsStore } from '@store/notifications.store';

interface DialogData {
  widgetId: number;
  widgetName: string;
  elementType: 'NEWS' | 'LINK' | 'DOCUMENT';
}

export interface GroupedUserNotification {
  userDisplayName?: string;
  userMail?: string;
  contracts: string;
  mailCount: number;
}

@Component({
  selector: 'app-notification-dialog',
  standalone: true,
  imports: [MatTableModule, MatIcon],
  providers: [NotificationsStore],
  templateUrl: './notification-dialog.component.html',
  styleUrl: './notification-dialog.component.scss',
})
export class NotificationDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<NotificationDialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly store = inject(NotificationsStore);

  displayedColumns = ['userDisplayName', 'userMail', 'contracts', 'mailCount'];

  groupedUsers = computed<GroupedUserNotification[]>(() => {
    const map = new Map<string, GroupedUserNotification>();
    for (const user of this.store.usersToBeNotified()) {
      const key = user.userMail ?? '';
      if (map.has(key)) {
        const entry = map.get(key)!;
        if (user.contractName && !entry.contracts.split(', ').includes(user.contractName)) {
          entry.contracts += `, ${user.contractName}`;
        }
        entry.mailCount++;
      } else {
        map.set(key, {
          userDisplayName: user.userDisplayName,
          userMail: user.userMail,
          contracts: user.contractName ?? '',
          mailCount: 1,
        });
      }
    }
    return Array.from(map.values());
  });

  ngOnInit(): void {
    this.store.loadUsersToBeNotified(this.data.widgetId);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  send(): void {
    this.store.notifyUsers(this.data.widgetId, this.data.elementType);
    this.dialogRef.close();
  }
}
